import BasePreview from 'gleam-shared/embeds/BasePreview'

export default function DeadPreview(description = 'The resource', error = null) {
  console.error(error)

  const preview = BasePreview({ destroy, description })
  const timeout = setTimeout(onTimeout)

  return preview

  function destroy() {
    clearTimeout(timeout)
  }

  function onTimeout() {
    const base = `${description} is misconfigured!`
    const message = error ? `${base} ${error.message}` : base
    preview.errorEmitter.emit(new Error(message))
  }
}
